
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...encyclopediaPaths]",
      function () {
        return require("private-next-pages/[...encyclopediaPaths].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...encyclopediaPaths]"])
      });
    }
  